import { render, staticRenderFns } from "./transportInfo.vue?vue&type=template&id=3d66f4ce"
import script from "./transportInfo.vue?vue&type=script&lang=js"
export * from "./transportInfo.vue?vue&type=script&lang=js"
import style0 from "./transportInfo.vue?vue&type=style&index=0&id=3d66f4ce&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports